module.exports = __webpack_public_path__ + "img/template_5.fa3adc0e.png";